export default "__VITE_ASSET__Dn0aoFp5__"